(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wb-partner-content"] && !Shopify.designMode) return;
  try {
    // Responsive Google Form iframe sizing — mobile-safe, cross-origin tolerant.
  (function () {
    function resizePartnerForm() {
      var wrap = document.querySelector('.wb-partner-form__iframe-wrap');
      var frame = wrap && wrap.querySelector('iframe');
      if (!wrap || !frame) return;

      // Strip fixed attributes so CSS min-width:100% + width:1px wins
      frame.removeAttribute('width');
      frame.removeAttribute('height');
      frame.style.width = '100%';
      frame.style.display = 'block';

      // Desktop/mobile-aware height. Google Forms iframe content is ~1752px tall.
      // Use a viewport-aware value so mobile doesn't get cut off or double-scrolled.
      if (window.innerWidth < 750) {
        frame.style.height = '2200px';
      } else {
        frame.style.height = Math.max(1752, window.innerHeight - 160) + 'px';
      }
    }

    // Retry in case the iframe hasn't loaded its final height yet
    function onReady(cb) {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', cb);
      } else {
        cb();
      }
    }
    onReady(resizePartnerForm);
    window.addEventListener('resize', function () {
      var t;
      return function () { clearTimeout(t); t = setTimeout(resizePartnerForm, 200); }
    }());
  })();
  } catch(e) { console.error(e); }
})();

})();
